var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.636986 1.43396L9.37699 10.005L0.701986 18.655C0.56006 18.4701 0.449888 18.263 0.375986 18.042C0.337765 17.7917 0.337765 17.5372 0.375986 17.287V2.56696C0.349986 2.17196 0.440986 1.77696 0.635986 1.43396M13.142 6.26696L10.289 9.09296L1.65299 0.599956C1.93299 0.502956 2.23299 0.475957 2.52599 0.521957C2.98599 0.647957 3.42499 0.841957 3.82799 1.09496L11.644 5.41996C12.152 5.69296 12.647 5.97996 13.142 6.26696ZM10.29 10.93L13.129 13.718L11.071 14.864L4.79199 18.354C4.27199 18.641 3.74999 18.915 3.24199 19.228C3.02461 19.3633 2.78087 19.4507 2.52703 19.4843C2.27319 19.5179 2.0151 19.497 1.76999 19.423L10.29 10.93ZM17.65 10.005C17.6573 10.3546 17.5689 10.6997 17.3944 11.0028C17.22 11.3059 16.966 11.5556 16.66 11.725L14.314 13.027L11.227 10.005L14.327 6.93096C15.122 7.37396 15.904 7.81696 16.685 8.23396C16.9965 8.40805 17.2523 8.66676 17.4229 8.98016C17.5935 9.29357 17.6729 9.64886 17.65 10.005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/PlayStore-Logo.c0c60a32278fb8551990541e90f9234f.svg";
export { ForwardRef as ReactComponent };